/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommCalendarData } from './ecomm-calendar.data';
import { IEcommCalendarProps } from './ecomm-calendar.props.autogenerated';

export interface IEcommCalendarViewProps extends IEcommCalendarProps<IEcommCalendarData> {}

/**
 *
 * EcommCalendar component
 * @extends {React.PureComponent<IEcommCalendarProps<IEcommCalendarData>>}
 */
class EcommCalendar extends React.PureComponent<IEcommCalendarProps<IEcommCalendarData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default EcommCalendar;
